import { render } from "./TranslationOptionsModal.vue?vue&type=template&id=40814abd"
import script from "./TranslationOptionsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslationOptionsModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/TranslationOptionsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40814abd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40814abd', __exports__)) {
    api.reload('40814abd', __exports__)
  }
  
  module.hot.accept("./TranslationOptionsModal.vue?vue&type=template&id=40814abd", () => {
    api.rerender('40814abd', render)
  })

}


export default __exports__